
import { createStyles } from 'antd-style';
import type React from 'react';
import type { ReactNode } from 'react';
import { TouchSafeTooltip as Tooltip } from '../TouchSafeTooltip';

const useStyles = createStyles(({ token, css }) => ({
  label: css`
    display: flex;
    align-items: center;
    gap: ${token.marginXXS}px;
    margin-bottom: ${token.marginXXS}px;
    color: ${token.colorTextSecondary};
    font-size: ${token.fontSizeSM}px;
    line-height: ${token.lineHeightSM};
  `,
  inline: css`
    display: inline-flex;
    margin-bottom: 0;
  `,
  required: css`
    color: ${token.colorErrorText};
  `,
  hint: css`
    color: ${token.colorTextTertiary};
    cursor: help;
  `,
}));

export interface FieldLabelProps {
  children: ReactNode;
  required?: boolean;
  hint?: ReactNode;
  inline?: boolean;
  className?: string;
}

const FieldLabel: React.FC<FieldLabelProps> = ({
  children,
  required,
  hint,
  inline,
  className,
}) => {
  const { styles, cx } = useStyles();
  return (
    <div className={cx(styles.label, inline && styles.inline, className)}>
      <span>{children}</span>
      {required ? <span className={styles.required}>*</span> : null}
      {hint ? (
        <Tooltip title={hint}>
          <span className={styles.hint}>?</span>
        </Tooltip>
      ) : null}
    </div>
  );
};

export default FieldLabel;
